export enum TestType {
  UserInput,
  RealData
}
